import BannerAward2024 from '../img/banner/Award2024.png';
import Logo from '../img/event/2608/logo.png';
import Title from '../img/event/2608/title.png';
import TalkBoxes from '../img/event/2608/talk-boxes.png';
import CheckList from '../img/event/2608/check-list.png';
import Online_Session from '../img/event/online-session.png';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import React from 'react';
import { TextBox } from './common/TextBox';
import ReactPlayer from 'react-player';

const HomeschoolEvent202608 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />

      {/* 프로모션 섹션 1 */}
      <div className="flex w-full items-center justify-center overflow-hidden bg-[#F1FBF4]">
        <div className="flex w-full flex-col px-5 pt-8 sm:px-8 sm:pt-12 md:px-10 md:pt-16 lg:pt-20">
          <div className="mx-auto flex w-full flex-col items-center justify-center">
            {/* 로고 */}
            <div className="mx-auto w-full max-w-[90px] sm:max-w-[110px] md:max-w-[130px] lg:max-w-[150px]">
              <img src={Logo} alt="젭스 영어교실" className="block w-full" />
            </div>

            {/* 메인 타이틀 이미지 */}
            <div className="mt-6 w-full max-w-[260px] sm:mt-8 sm:max-w-[320px] md:max-w-[380px] lg:max-w-[430px]">
              <img
                src={Title}
                alt="개학 전, 마지막 점검 타이밍 2학기 준비 CHECK!"
                className="block w-full"
              />
            </div>

            {/* 말풍선 이미지 */}
            <div className="mt-6 w-full max-w-[310px] sm:mt-8 sm:max-w-[390px] md:max-w-[470px] lg:max-w-[520px]">
              <img
                src={TalkBoxes}
                alt="학부모 고민 문구"
                className="block w-full"
              />
            </div>

            <div className="mt-8 flex flex-col items-center text-center sm:mt-10 md:mt-12">
              <p className="text-base font-bold leading-relaxed text-black sm:text-xl md:text-2xl lg:text-3xl">
                혹시 내 이야기라면?
              </p>

              <p className="text-base font-bold leading-relaxed text-black sm:text-xl md:text-2xl lg:text-3xl">
                젭스영어교실과
                <span className="text-[#00B15E]"> CHECK ✅ </span>
                해봐요!
              </p>
            </div>

            {/* 체크리스트 이미지 */}
            <div className="mb-10 mt-6 flex w-full flex-col items-center sm:mb-14 sm:mt-8 md:mb-16">
              <img src={CheckList} alt="CHECK LIST" className="block w-full" />
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 2 */}
      <div className="flex w-full items-center justify-center overflow-hidden bg-[#201A05]">
        <div className="m-auto flex w-full flex-col px-5 py-10 sm:px-8 sm:py-14 md:px-10 md:py-16 lg:py-20">
          <div className="m-auto flex w-full max-w-[520px] flex-col gap-5 sm:gap-7 md:max-w-[620px] md:gap-8 lg:max-w-[720px]">
            {/* 설명회 타이틀 */}
            <section className="flex flex-col text-center sm:gap-1">
              <div className="text-lg font-semibold text-white sm:text-xl md:text-2xl lg:text-3xl">
                내 고민과 비슷하다면?
              </div>

              <div className="text-xl font-extrabold leading-snug text-[#F9E385] sm:text-2xl md:text-3xl lg:text-4xl">
                온라인 설명회에서 그 답을 찾아보세요!
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full max-w-[360px] sm:max-w-[460px] md:max-w-[560px] lg:max-w-[640px]">
              <img
                src={Online_Session}
                alt="젭스영어교실 온라인설명회"
                className="block w-full"
              />
            </div>

            {/* 버튼 */}
            <div className="mx-auto w-full max-w-[360px] sm:max-w-[460px] md:max-w-[560px] lg:max-w-[640px]">
              <DoubleLineButton
                onClick={() => {
                  window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
                }}
                borderColor="border-white"
                bgColor="bg-black"
                hoverBgColor="hover:bg-black/10"
                textColor="text-white"
              >
                <div className="px-4 py-3 text-base font-bold sm:px-5 sm:py-4 sm:text-2xl md:text-3xl lg:text-4xl">
                  지금 설명회 신청하기
                </div>
              </DoubleLineButton>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="flex w-full items-center justify-center overflow-hidden bg-[#FAFFFA]">
        <div className="flex w-full flex-col px-5 pt-8 sm:px-8 sm:pt-12 md:px-10 md:pt-16 lg:pt-20">
          <div className="mx-auto flex w-full flex-col items-center justify-center">
            <div className="mb-8 flex flex-col items-center text-center sm:mb-10 md:mb-12">
              <p className="flex flex-col gap-2 font-extrabold leading-relaxed text-black sm:gap-3">
                <span className="bg-[#FFF9A7] px-4 py-1 text-lg sm:px-5 sm:py-1.5 sm:text-xl md:px-6 md:text-2xl lg:px-7 lg:text-3xl xl:px-8 xl:py-2 xl:text-3xl">
                  편해진 관리, 안정된 시스템
                </span>

                <span className="bg-[#FFF9A7] px-4 py-1 text-xl sm:px-5 sm:py-1.5 sm:text-2xl md:px-6 md:text-3xl lg:px-7 lg:text-4xl xl:px-8 xl:py-2 xl:text-4xl">
                  선생님의 든든한 조력자
                </span>
              </p>
            </div>

            <div className="mb-8 flex flex-col items-center text-center sm:mb-10 md:mb-12">
              <p className="flex flex-col gap-2 font-extrabold leading-relaxed text-[#E97132] sm:gap-3">
                <span className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-4xl">
                  8월 LMS 업데이트가 궁금하다면?!
                </span>

                <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-5xl">
                  영상으로 시청하기!
                </span>
              </p>
            </div>

            <div className="mx-auto mb-16 aspect-video w-full max-w-[340px] overflow-hidden rounded-xl sm:max-w-[520px] md:max-w-[680px] lg:max-w-[720px]">
              <ReactPlayer
                width="100%"
                height="100%"
                url="https://youtu.be/ZT1timC1Nv0?si=uy9SZfNsdjBxXTaC"
                controls
              />
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 4 */}
      <div className="flex w-full items-center justify-center bg-gray2">
        <div className="m-auto flex w-full flex-col bg-[#00B15E] px-5 py-10 sm:px-8 sm:py-14 md:px-10 md:py-16 lg:py-20">
          <div className="mx-auto w-full max-w-[520px] md:max-w-[620px] lg:max-w-[720px]">
            {/* 상단 문구 */}
            <div className="mb-4 flex flex-col items-center text-center sm:mb-5 md:mb-6">
              <p className="text-2xl font-extrabold leading-tight text-white sm:text-3xl md:text-4xl lg:text-5xl">
                다가올 개학 준비,
                <br />
                젭스가 이렇게 도울게요!
              </p>
            </div>

            <div className="mb-8 flex flex-col items-center text-center sm:mb-10 md:mb-12">
              <p className="text-base font-extrabold leading-relaxed text-white sm:text-xl md:text-2xl lg:text-3xl">
                우리 아이 영어&신앙 고민을
                <br />
                <span className="text-[#F9E385]">
                  모두 극복할 수 있는 완벽 해결책,
                </span>
                <br />
                젭스영어교실의 비법을 소개합니다!
              </p>
            </div>

            {/* 하단 박스 */}
            <section className="flex w-full flex-col gap-4 sm:gap-5 md:gap-6">
              <div className="grid auto-rows-fr grid-cols-1 gap-4 sm:gap-5 md:gap-6">
                <TextBox className="h-full">
                  <p className="text-base font-extrabold leading-relaxed text-black sm:text-xl md:text-2xl lg:text-3xl">
                    삽화기억술 & A.D. 영어 학습법으로
                    <br />
                    <span className="text-[#00B15E]">
                      저절로 각인되는 영어!
                    </span>
                  </p>
                </TextBox>

                <TextBox className="h-full">
                  <p className="text-base font-extrabold leading-relaxed text-black sm:text-xl md:text-2xl lg:text-3xl">
                    <span className="text-[#00B15E]">성경 스토리</span>로 재밌게
                    <br />
                    믿음까지 성장!
                  </p>
                </TextBox>

                <TextBox className="h-full">
                  <p className="text-base font-extrabold leading-relaxed text-black sm:text-xl md:text-2xl lg:text-3xl">
                    문법부터 스피킹까지
                    <br />
                    말하는 영문법으로{' '}
                    <span className="text-[#00B15E]">한 번에</span>!
                  </p>
                </TextBox>
              </div>
            </section>

            <div className="m-auto flex w-full flex-col px-0 pb-0 pt-10 sm:pt-12 md:pt-14 lg:pt-16">
              <p className="text-center text-base font-extrabold leading-relaxed text-white sm:text-xl md:text-2xl lg:text-3xl">
                8월 2학기 준비 특별 혜택으로
                <br />
                재밌고 행복한 영어 학습 첫걸음을
                <br />
                시작해 보세요!✨
              </p>

              {/* 버튼 */}
              <div className="mx-auto mt-8 w-full max-w-[360px] sm:mt-10 sm:max-w-[520px] md:mt-12 md:max-w-[640px]">
                <DoubleLineWithCursorButton
                  onClick={() => {
                    window.open(
                      'https://jebs.kr/shop/details/NKyRTHjIgiewcumT',
                    );
                  }}
                  bgColor="bg-black"
                  hoverBgColor="hover:bg-black/70"
                  textColor="text-white"
                >
                  <div className="px-4 py-3 text-base font-bold sm:px-6 sm:py-4 sm:text-2xl md:text-3xl lg:px-8 lg:py-5 lg:text-3xl">
                    8월 젭스영어교실&nbsp;
                    <span className="text-[#FDF4B4]">등록하고 혜택 받기</span>
                  </div>
                </DoubleLineWithCursorButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202608;
